export const outputPresetTypes = Object.freeze({
  ALL: null,
  SYSTEM: 0,
  CUSTOM: 1,
})

export const getPresetTypeName = val => {
  switch (val) {
    case outputPresetTypes.ALL:
      return 'Any'
    case outputPresetTypes.SYSTEM:
      return 'System'
    case outputPresetTypes.CUSTOM:
      return 'Custom'
    default:
      return ''
  }
}
